"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLazyEntry = void 0;
var RegistryError_1 = require("../../errors/RegistryError");
var createComponentLoader_1 = require("../../componentLoader/createComponentLoader");
var loadBundle_1 = require("../../componentLoader/loadBundle");
var loadAssets_1 = require("../../componentLoader/loadAssets");
var createEnvironmentLoader_1 = require("../../componentLoader/createEnvironmentLoader");
var createStaticComponentsLoaders_1 = require("./createStaticComponentsLoaders");
var registerComponents_1 = require("./registerComponents");
function createDuplicatedComponentError(componentName, context) {
    if (context === void 0) { context = ''; }
    var error = RegistryError_1.createException('Duplicated component', RegistryError_1.RegistryErrorCode.IncorrectBatches)
        .withComponent(componentName)
        .withHint('Probably the same component exists in the different libraries');
    if (context) {
        error.withDetails("Context \u2013 " + context);
    }
    return error;
}
function loadBatchComponents(_a) {
    var _this = this;
    var transport = _a.transport, batches = _a.batches, manifest = _a.manifest, shouldLoadCSSAssets = _a.shouldLoadCSSAssets, environmentLoader = _a.environmentLoader;
    var tasks = Object.keys(manifest.batches)
        .filter(function (batchName) { return batches.includes(batchName); })
        .map(function (batchName) { return __awaiter(_this, void 0, void 0, function () {
        var batch, batchComponents, componentsInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    batch = manifest.batches[batchName];
                    return [4 /*yield*/, loadBundle_1.loadBundleComponents(transport, batch.id, batch.url, environmentLoader)];
                case 1:
                    batchComponents = _a.sent();
                    if (shouldLoadCSSAssets) {
                        loadAssets_1.loadBatchAssets(manifest.assets, batchName);
                    }
                    componentsInfo = {};
                    return [2 /*return*/, createStaticComponentsLoaders_1.createStaticComponentsLoaders(batchComponents.components, componentsInfo, manifest, batchName)];
            }
        });
    }); });
    return Promise.all(tasks);
}
function loadComponentsInfo(infoManifests, _a) {
    var transport = _a.transport, environmentLoaders = _a.environmentLoaders;
    return __awaiter(this, void 0, void 0, function () {
        var tasks;
        var _this = this;
        return __generator(this, function (_b) {
            tasks = infoManifests
                .filter(function (_a) {
                var manifest = _a.manifest;
                return manifest.url && manifest.id;
            })
                .map(function (context) { return __awaiter(_this, void 0, void 0, function () {
                var environmentLoader, id, url, info;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            environmentLoader = environmentLoaders[context.library.artifactId];
                            id = context.manifest.id;
                            url = context.manifest.url;
                            return [4 /*yield*/, loadBundle_1.loadBundleComponents(transport, id, url, environmentLoader)];
                        case 1:
                            info = (_a.sent()).info;
                            return [2 /*return*/, {
                                    artifactId: context.library.artifactId,
                                    components: info,
                                }];
                    }
                });
            }); });
            return [2 /*return*/, Promise.all(tasks)];
        });
    });
}
function createBatchComponentLoaders(manifests, _a) {
    var transport = _a.transport, batches = _a.batches, shouldLoadCSSAssets = _a.shouldLoadCSSAssets, environmentLoaders = _a.environmentLoaders;
    return __awaiter(this, void 0, void 0, function () {
        var tasks;
        var _this = this;
        return __generator(this, function (_b) {
            tasks = manifests.map(function (context) { return __awaiter(_this, void 0, void 0, function () {
                var batchComponents, _a, components;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(batches && batches.length)) return [3 /*break*/, 2];
                            return [4 /*yield*/, loadBatchComponents({
                                    transport: transport,
                                    batches: batches,
                                    manifest: context.manifest,
                                    shouldLoadCSSAssets: shouldLoadCSSAssets,
                                    environmentLoader: environmentLoaders[context.library.artifactId],
                                })];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = [];
                            _b.label = 3;
                        case 3:
                            batchComponents = _a;
                            components = {};
                            batchComponents.forEach(function (batch) {
                                Object.keys(batch).forEach(function (componentName) {
                                    if (components[componentName]) {
                                        var error = RegistryError_1.createException('Duplicated component. Presents in different batches', RegistryError_1.RegistryErrorCode.IncorrectBatches)
                                            .withComponent(componentName)
                                            .withLibrary(context.library.artifactId);
                                        console.warn(error.message);
                                    }
                                    components[componentName] = batch[componentName];
                                });
                            });
                            return [2 /*return*/, {
                                    context: context,
                                    components: components,
                                }];
                    }
                });
            }); });
            return [2 /*return*/, Promise.all(tasks)];
        });
    });
}
function createComponentLoaders(manifests, _a) {
    var transport = _a.transport, shouldLoadCSSAssets = _a.shouldLoadCSSAssets, environmentLoaders = _a.environmentLoaders;
    return manifests.map(function (context) {
        var components = {};
        Object.keys(context.manifest.components).forEach(function (componentName) {
            var component = context.manifest.components[componentName];
            if (components[componentName]) {
                var error = createDuplicatedComponentError(componentName, 'library manifest');
                console.warn(error.message);
            }
            components[componentName] = createComponentLoader_1.createComponentLoader({
                transport: transport,
                component: component,
                shouldLoadCSSAssets: shouldLoadCSSAssets,
                environmentLoader: environmentLoaders[context.library.artifactId],
            });
        });
        return {
            context: context,
            components: components,
        };
    });
}
/**
 * Main
 */
function createLazyEntry(_a) {
    var _this = this;
    var manifests = _a.manifests, infoManifests = _a.infoManifests, transport = _a.transport;
    return function (params) { return __awaiter(_this, void 0, void 0, function () {
        function loadComponentsInfoIfRequired() {
            return params.shouldLoadComponentsInfo
                ? loadComponentsInfo(infoManifests, {
                    transport: transport,
                    environmentLoaders: environmentLoaders,
                })
                : [];
        }
        var environmentLoaders, componentsInfoPromise, batchComponentsLoadersPromise, componentLoaders, _a, componentsInfo, batchComponentsLoaders;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    environmentLoaders = {};
                    manifests.forEach(function (_a) {
                        var library = _a.library;
                        var environmentLoader = createEnvironmentLoader_1.createEnvironmentLoader(transport, library.environment);
                        environmentLoaders[library.artifactId] = environmentLoader;
                    });
                    componentsInfoPromise = params.info
                        ? Promise.resolve(params.info)
                        : loadComponentsInfoIfRequired();
                    batchComponentsLoadersPromise = createBatchComponentLoaders(manifests, {
                        transport: transport,
                        batches: params.batches,
                        shouldLoadCSSAssets: params.shouldLoadCSSAssets
                            ? params.shouldLoadCSSAssets
                            : false,
                        environmentLoaders: environmentLoaders,
                    });
                    componentLoaders = createComponentLoaders(manifests, {
                        transport: transport,
                        shouldLoadCSSAssets: params.shouldLoadCSSAssets
                            ? params.shouldLoadCSSAssets
                            : false,
                        environmentLoaders: environmentLoaders,
                    });
                    return [4 /*yield*/, Promise.all([
                            componentsInfoPromise,
                            batchComponentsLoadersPromise,
                        ])];
                case 1:
                    _a = _b.sent(), componentsInfo = _a[0], batchComponentsLoaders = _a[1];
                    componentLoaders.forEach(function (libraryComponents) {
                        var components = __assign({}, libraryComponents.components);
                        /**
                         * add components from batches
                         */
                        var libraryBatchComponents = batchComponentsLoaders.find(function (_a) {
                            var context = _a.context;
                            return libraryComponents.context.library.artifactId ===
                                context.library.artifactId;
                        });
                        if (libraryBatchComponents) {
                            Object.assign(components, libraryBatchComponents.components);
                        }
                        /**
                         * Add components info
                         * first - get all components info from the same library as `libraryComponents`
                         */
                        var libraryComponentsInfo = componentsInfo.find(function (_a) {
                            var artifactId = _a.artifactId;
                            return libraryComponents.context.library.artifactId === artifactId;
                        });
                        if (libraryComponentsInfo) {
                            Object.keys(libraryComponentsInfo.components).forEach(function (componentName) {
                                if (components[componentName]) {
                                    components[componentName].info =
                                        libraryComponentsInfo.components[componentName];
                                }
                            });
                        }
                        registerComponents_1.registerComponents(components, libraryComponents.context, {
                            registerComponent: params.registerComponent,
                            registerLibrary: params.registerLibrary,
                        });
                    });
                    return [2 /*return*/, {
                            info: componentsInfo,
                        }];
            }
        });
    }); };
}
exports.createLazyEntry = createLazyEntry;
//# sourceMappingURL=createLazyEntry.js.map